module.exports = __webpack_public_path__ + "img/workbench_icon3.63be95b1.svg";